import type { CanDeactivateFn } from '@angular/router';
import type { SmartAddPageComponent } from './smart-add-page.component';

export const smartAddPendingChangesGuard: CanDeactivateFn<SmartAddPageComponent> = (component) => component.canLeave();
